import { Box } from "@mui/material"
import { type RowSelectionState, getCoreRowModel } from "@tanstack/react-table"
import type { FC } from "react"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { CompanyCertification, SignedUrl } from "@/graphql/codegen/graphql"
import { useCertificationColumns } from "@/screens/Companies/edit/components/certification/hooks/useCertificationColumns"
import type { TransformedCertificationTableItem } from "@/screens/Companies/edit/components/certification/types"

interface CertificationTableProps {
  data: TransformedCertificationTableItem[]
  fileList: SignedUrl[]
  selected: Record<string, boolean>
  setSelected: (selected: Record<string, boolean>) => void
  onEdit: (companyCertification: CompanyCertification) => void
}

const CertificationTable: FC<CertificationTableProps> = ({ data, selected, setSelected, fileList, onEdit }) => {
  const handleRowSelectionChange = (
    updaterOrValue: ((old: RowSelectionState) => RowSelectionState) | RowSelectionState
  ) => {
    const newSelection = typeof updaterOrValue === "function" ? updaterOrValue(selected) : updaterOrValue
    setSelected(newSelection)
  }

  const columns = useCertificationColumns({ fileData: fileList, onEdit })

  return (
    <Box className='flex h-full flex-col'>
      <AerosBaseTable
        features={{
          table: {
            stickyHeader: true,
          },
          tanstackOptions: {
            data,
            columns,
            state: {
              rowSelection: selected,
            },
            getCoreRowModel: getCoreRowModel(),
            enableMultiRowSelection: true,
            enableRowSelection: true,
            getRowId: (row) => row?.location?.locationId,
            onRowSelectionChange: handleRowSelectionChange,
          },
        }}
        slotProps={{
          bodyRow: {
            className: "hover:bg-primary-100 cursor-pointer",
          },
        }}
      />
    </Box>
  )
}

export default CertificationTable
